module.exports = __webpack_public_path__ + "img/mc_x.cc974899.jpg";